import { Helmet } from "react-helmet-async";
import { PageHero } from "@/components/shared/PageHero";
import { CTASection } from "@/components/shared/CTASection";
import vanceImage from "@/assets/vance-riekels.png";
import lawnImage from "@/assets/hero-lawn-striped.jpg";

const About = () => {
  return (
    <>
      <Helmet>
        <title>About Us | Riekels Lawn Care & Landscaping</title>
        <meta
          name="description"
          content="Meet Vance Riekels—the West Metro's passionate lawn care expert. Learn about Riekels Lawn Care & Landscaping and our commitment to quality service."
        />
      </Helmet>
      <main>
        <PageHero
          badge="About Us"
          title="Your Local Lawn Care Experts"
          subtitle="Quality service and attention to detail for every property we serve."
        />

        <section className="py-20">
          <div className="container mx-auto px-4">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-20">
              <div>
                <img
                  src={vanceImage}
                  alt="Vance Riekels - Owner of Riekels Lawn Care & Landscaping"
                  className="rounded-3xl shadow-xl w-full max-w-md mx-auto"
                />
              </div>
              <div className="space-y-6">
                <span className="section-badge">Meet The Owner</span>
                <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground">
                  Vance Riekels
                </h2>
                <h3 className="text-xl font-heading font-semibold text-secondary">
                  A Lawn Obsession Turned Profession
                </h3>
                <p className="text-lg text-muted-foreground leading-relaxed">
                  I've been passionate about lawns since I was a teenager—so much so that nobody's 
                  been allowed to mow my family's lawn since I was 14. I've been learning, testing, 
                  and perfecting my approach for years. I can spot grass types at a glance and tell 
                  what a lawn needs within minutes. That same attention to detail is what we bring 
                  to every client's property.
                </p>
                <p className="text-lg text-muted-foreground leading-relaxed">
                  When you reach out to Riekels, you talk to me directly. No phone trees. No middlemen. 
                  I take the trust my clients place in me very seriously and I will give your project 
                  the same care and attention I would give my own. Whether it is choosing the staff 
                  that I trust or the right treatment plan for your outdoor space, providing the best 
                  for my clients is my highest priority.
                </p>
              </div>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              <div className="lg:order-2">
                <img
                  src={lawnImage}
                  alt="Beautiful striped lawn by Riekels"
                  className="rounded-3xl shadow-xl w-full"
                />
              </div>
              <div className="space-y-6 lg:order-1">
                <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground">
                  Fully Insured
                </h2>
                <p className="text-lg text-muted-foreground leading-relaxed">
                  We're fully insured for your protection. Every project we 
                  complete is done with care and professionalism.
                </p>
                <p className="text-lg text-muted-foreground leading-relaxed">
                  Our team uses professional-grade equipment and stays current with the latest techniques. 
                  When you work with Riekels, you're getting experienced professionals 
                  who take pride in their craft.
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="py-20 bg-section-alt">
          <div className="container mx-auto px-4">
            <div className="max-w-3xl mx-auto text-center">
              <h2 className="text-3xl font-heading font-bold text-foreground mb-8">
                Why Choose Riekels?
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                <div className="feature-card text-center">
                  <div className="text-4xl font-heading font-bold text-secondary mb-2">MN</div>
                  <p className="text-muted-foreground">Locally Owned</p>
                </div>
                <div className="feature-card text-center">
                  <div className="text-4xl font-heading font-bold text-secondary mb-2">100%</div>
                  <p className="text-muted-foreground">Satisfaction Guaranteed</p>
                </div>
                <div className="feature-card text-center">
                  <div className="text-4xl font-heading font-bold text-secondary mb-2">★★★★★</div>
                  <p className="text-muted-foreground">5-Star Reviews</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <CTASection />
      </main>
    </>
  );
};

export default About;
